import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { deactivateBusiness } from '~/services/BusinessTraveller/BusinessTravellerService';

export const deactivateBusinessQueryKeys = {
  preview: (businessId: string) => ['deactivate-business', 'preview', businessId],
};

export function useDeactivateBusinessPreview(businessId: string, enabled: boolean) {
  return useQuery({
    queryKey: deactivateBusinessQueryKeys.preview(businessId),
    queryFn: () => deactivateBusiness(businessId, { preview: true, reason: '' }),
    enabled,
  });
}

export function useDeactivateBusiness() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ businessId, reason }: { businessId: string; reason: string }) =>
      deactivateBusiness(businessId, { preview: false, reason }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['business'] });
    },
  });
}
